import { Message, toaster } from 'rsuite'

// Derived from the component instead of imported from rsuite's internals:
// that path no longer exports TypeAttributes, and an internal path is not part
// of the package's public surface anyway.
export type ToastStatus = NonNullable<React.ComponentProps<typeof Message>['type']>

export default function toastMessage(message: string, type: ToastStatus = 'success', duration = 3000) {
    toaster.push(
        <Message showIcon type={type}>
            {message}
        </Message>,
        { placement: 'bottomEnd', duration }
    )
}

export function toastError(message: string) {
    toastMessage(message, 'error')
}

export function toastSuccess(message: string) {
    toastMessage(message, 'success')
}
